import { Component } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-page-under-contruction',
  imports: [AngularSvgIconModule],
  templateUrl: './page-under-contruction.component.html',
})
export class PageUnderContructionComponent {}
